var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPageback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.338 19.7032L0.39748 10.8838C-0.132493 10.4135 -0.132493 9.58649 0.39748 9.11696L10.338 0.297586C10.8259 -0.13509 11.5726 -0.0908646 12.0053 0.397094L12.3945 0.835667C12.8272 1.32363 12.7829 2.07031 12.295 2.50298L3.84415 10L12.2942 17.497C12.7822 17.9297 12.8272 18.6764 12.3937 19.1643L12.0046 19.6029C11.5719 20.0909 10.8252 20.1351 10.3372 19.7024L10.338 19.7032Z",
    fill: "#55C595"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPageback);
export default __webpack_public_path__ + "static/media/icon_pageback.c251a8b513a306379590e2f50fbd1111.svg";
export { ForwardRef as ReactComponent };